import { render, staticRenderFns } from "./AboutTA7.vue?vue&type=template&id=5e6b161f&scoped=true&"
import script from "./AboutTA7.vue?vue&type=script&lang=js&"
export * from "./AboutTA7.vue?vue&type=script&lang=js&"
import style0 from "./AboutTA7.vue?vue&type=style&index=0&id=5e6b161f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6b161f",
  null
  
)

export default component.exports